import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { z } from 'zod';

import { useApi } from '@/lib/api-context';

// Reprogramación de la vigencia (G4, cierre F1): POST
// /api/v1/quality/documents/:entryId/effective-date con motivo. Refresca la etapa, la
// ficha, el editor y la lista (la vigencia se ve en todas).

const resultSchema = z.object({
  success: z.literal(true),
  data: z.object({ effectiveDate: z.string(), lmsSynced: z.boolean() }),
});
export type RescheduleResult = z.infer<typeof resultSchema>['data'];

export interface RescheduleVars {
  entryId: string;
  effectiveDate: string;
  reason: string;
}

export function useReschedule(): UseMutationResult<RescheduleResult, Error, RescheduleVars> {
  const api = useApi();
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ entryId, effectiveDate, reason }: RescheduleVars) => {
      const raw = await api.post<unknown>(`/api/v1/quality/documents/${entryId}/effective-date`, {
        effectiveDate,
        reason,
      });
      return resultSchema.parse(raw).data;
    },
    onSuccess: () => {
      for (const key of ['training-stage', 'dossier', 'flow-capabilities', 'master-list']) {
        void qc.invalidateQueries({ queryKey: [key] });
      }
    },
  });
}
